import { useTranslation } from 'react-i18next';
import { trackTrendyolConversion } from '../../../hooks/useConversionTracking';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToOrder = () => {
    const element = document.getElementById('mysa-products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/1681d69a5b156bf16fd7f9a96245b161/d8709aa73fddb25bacaa9555a2c9a6d4.png"
          alt="MYSA Pilates Reformer"
          className="w-full h-full object-cover object-center md:object-left"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>
      
      <div className="relative z-10 max-w-2xl mx-auto px-6 text-center w-full">
        <h1 className="text-3xl md:text-5xl font-bold mb-4 leading-tight" style={{ color: '#FFF8F0', textShadow: '0 2px 16px rgba(0,0,0,0.25)' }}>
          {t('hero.title')}<br />{t('hero.titleLine2')}
        </h1>
        <p className="text-base md:text-lg mb-12 max-w-xl mx-auto leading-relaxed font-light" style={{ color: 'rgba(255,248,240,0.85)', textShadow: '0 1px 8px rgba(0,0,0,0.2)' }}>
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <button
            onClick={scrollToOrder}
            className="bg-stone-800/70 backdrop-blur-sm text-amber-50 px-6 py-2.5 rounded-full text-xs font-medium hover:bg-stone-800/90 transition-colors duration-300 whitespace-nowrap tracking-widest uppercase border border-white/10 cursor-pointer"
          >
            {t('hero.orderNow')}
          </button>
          <button
            onClick={() => {
              const element = document.getElementById('gallery');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white/10 backdrop-blur-sm text-amber-50 px-6 py-2.5 rounded-full text-xs font-medium hover:bg-white/20 transition-colors duration-300 border border-white/30 whitespace-nowrap tracking-widest uppercase cursor-pointer"
          >
            {t('hero.discoverMore')}
          </button>
        </div>
      </div>

      <a
        href="https://ty.gl/1xexcnsg70rfw"
        target="_blank"
        rel="noopener noreferrer nofollow"
        onClick={trackTrendyolConversion}
        className="absolute bottom-6 right-6 z-10 cursor-pointer hover:opacity-80 transition-opacity duration-300"
      >
        <div className="w-9 h-9 flex items-center justify-center">
          <img 
            src="https://static.readdy.ai/image/1681d69a5b156bf16fd7f9a96245b161/1225b9f0757d6eda468a41a32e7f04b6.png" 
            alt="Shop on Trendyol" 
            title="Shop on Trendyol"
            className="w-full h-full object-contain"
          />
        </div>
      </a>
    </section>
  );
}
